import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { routes } from './AppRoutes';
import Login from '../pages/Login/Login';

const UnprotectedRoutes: React.FC = () => (
    <Routes>
        <Route path={routes.Login} element={<Login/>} />
        <Route path={routes.Index} element={<Login/>} />
        <Route
            path="*"
            element={<Navigate to="/" />}
        />
    </Routes>
)

export default UnprotectedRoutes;